// extracted by css-extract-rspack-plugin
module.exports =  {"charCount":"AddJobNoteDialog__charCount___jGVwN"};